import { Slardar } from '../lazyApp';

const runWhenIdle = (callback: () => void, timeout = 2000): number => {
  const requestIdleCallback = (window as any).requestIdleCallback as
    | ((cb: () => void, options?: { timeout: number }) => number)
    | undefined;

  if (typeof requestIdleCallback === 'function') {
    return requestIdleCallback(callback, { timeout });
  }

  return window.setTimeout(callback, timeout);
};

runWhenIdle(() => {
  import('@oec-seller/sdk/utils/slardar')
    .then(({ slardarInit }) => {
      slardarInit({ bid: 'i18n_ecom_contact_us' });
      Slardar.start();
    })
    .catch(err => {
      console.error('Failed to init slardar', err);
    });
});
